const ORCAWEB_SERVICE_WORKER_URL = '/orcaweb-sw.js';

export const registerOrcaWebServiceWorker = (): void => {
    if (!('serviceWorker' in navigator)) {
        return;
    }

    navigator.serviceWorker
        .register(ORCAWEB_SERVICE_WORKER_URL, {
            type: 'module',
            updateViaCache: 'none',
        })
        .catch((error: unknown) => {
            console.warn('Error registering service worker:', error);
        });
};
